"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackAsyncIntegration = void 0;

var _feedback = require("@sentry-internal/feedback");

var _lazyLoadIntegration = require("./utils/lazyLoadIntegration.js");

/**
 * An integration to add user feedback to your application,
 * while loading most of the code lazily only when it's needed.
 */
const feedbackAsyncIntegration = exports.feedbackAsyncIntegration = (0, _feedback.buildFeedbackIntegration)({
  lazyLoadIntegration: _lazyLoadIntegration.lazyLoadIntegration
});